import React from 'react'
import styles from './statistic-modal.module.scss'

export default function SendStatisticStepFour() {
  return (
    <div className={styles['statisticStepFour']}>
      <b>
        <span role="img" aria-label="Party popper emoji">
          🎉
        </span>{' '}
        Thank you for your feedback!
      </b>
      <p>If you need to hire more crew members in the future, we’re always here to assist you.</p>
    </div>
  )
}
